import { ArrowRight } from "lucide-react";
import { trackLead } from "@/lib/metaPixel";

const CHECKLIST_URL = "https://form.typeform.com/to/XkdcuYHA";
const CLICKS_URL = `${process.env.REACT_APP_BACKEND_URL}/api/clicks`;

export default function LeadForm() {
  const handleClick = () => {
    trackLead("checklist_cta");
    fetch(CLICKS_URL, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event_source_url: window.location.href }),
    }).catch(() => {});
  };

  return (
    <a
      data-testid="lead-submit-button"
      href={CHECKLIST_URL}
      onClick={handleClick}
      className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#1A1F5E] px-8 py-4 text-sm font-bold uppercase tracking-widest text-[#F7F6F2] transition-[background-color,transform] duration-300 hover:scale-[1.03] hover:bg-[#121644] active:scale-[0.98]"
    >
      Send me the free checklist
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </a>
  );
}
